export { Minus as default } from './Minus';
